import React from "react";
import { MdFilterListOff } from "react-icons/md";

const InscriptionFilters = ({ 
  filters, 
  onFilterChange, 
  onResetFilters, 
  uniqueAnnees = [],
  uniqueNiveaux = [],
  uniqueParcours = [],
  uniqueMentions = []
}) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onFilterChange({ [name]: value });
  };

  return (
    <div className="mb-6 rounded-lg border border-gray-200 bg-gray-50 p-4">
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-sm font-medium text-gray-700">Filtres avancés</h3>
        <button
          onClick={onResetFilters}
          className="flex items-center gap-1 text-sm text-gray-600 hover:text-gray-900"
        >
          <MdFilterListOff className="h-4 w-4" />
          <span>Réinitialiser</span>
        </button>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
        <div>
          <label htmlFor="anneeUniv" className="block text-xs font-medium text-gray-700">
            Année universitaire
          </label>
          <select
            id="anneeUniv"
            name="anneeUniv"
            value={filters.anneeUniv || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-purple-500 focus:outline-none focus:ring-purple-500"
          >
            <option value="">Toutes les années</option>
            {uniqueAnnees.map((annee, index) => (
              <option key={index} value={annee}>{annee}</option>
            ))}
          </select>
        </div>
        
        <div>
          <label htmlFor="niveau" className="block text-xs font-medium text-gray-700">
            Niveau
          </label>
          <select
            id="niveau"
            name="niveau"
            value={filters.niveau || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-purple-500 focus:outline-none focus:ring-purple-500"
          >
            <option value="">Tous les niveaux</option>
            {uniqueNiveaux.map((niveau, index) => (
              <option key={index} value={niveau}>{niveau}</option>
            ))}
          </select>
        </div>
        
        <div>
          <label htmlFor="parcours" className="block text-xs font-medium text-gray-700">
            Parcours
          </label>
          <select
            id="parcours"
            name="parcours"
            value={filters.parcours || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-purple-500 focus:outline-none focus:ring-purple-500"
          >
            <option value="">Tous les parcours</option>
            {uniqueParcours.map((parcours, index) => (
              <option key={index} value={parcours}>{parcours}</option>
            ))}
          </select>
        </div>
        
        <div>
          <label htmlFor="mention" className="block text-xs font-medium text-gray-700">
            Mention
          </label>
          <select
            id="mention"
            name="mention"
            value={filters.mention || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-purple-500 focus:outline-none focus:ring-purple-500"
          >
            <option value="">Toutes les mentions</option>
            {uniqueMentions.map((mention, index) => (
              <option key={index} value={mention}>{mention}</option>
            ))}
          </select>
        </div>
        
        <div>
          <label htmlFor="dateDebut" className="block text-xs font-medium text-gray-700">
            Date début
          </label>
          <input
            type="date"
            id="dateDebut"
            name="dateDebut"
            value={filters.dateDebut || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-purple-500 focus:outline-none focus:ring-purple-500"
          />
        </div>
        
        <div>
          <label htmlFor="dateFin" className="block text-xs font-medium text-gray-700">
            Date fin
          </label>
          <input
            type="date"
            id="dateFin"
            name="dateFin"
            value={filters.dateFin || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-purple-500 focus:outline-none focus:ring-purple-500"
          />
        </div>
      </div>
    </div>
  );
};

export default InscriptionFilters;